import { AppRootScope } from '../../typings/AppRootScope';

/**
 * This directive will prevent the mousewheel from working on the element it is applied to.
 * It is useful for input[number], among others
 */

export class NoWheelDirective implements angular.IDirective {
    public static $name: string = 'noWheel';

    public link = (scope: AppRootScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        element.on('mousewheel', (event: JQueryEventObject) => {
            event.preventDefault();
        });
    }

    public static Factory() {
        let directive = () => {
            return new NoWheelDirective();
        };

        return directive;
    }
}
